import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, ArrowUpLeft, ChevronLeft } from 'lucide-react';
import { listTransaction } from "../services/authService";
import dayjs from 'dayjs';
import { getClientData, toIndianRupeeFormat } from "./custom";

function TransactionHistory() {
  const navigate = useNavigate();

  const [balance, setBalance] = React.useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const clientData = getClientData();

    if (clientData) {
      setClients(clientData);
    }

  }, []);

  const handleGoBack = () => {
    navigate("/account");
  };

  const handleDepositClick = () => {
    navigate('/account-deposit');
  };

  const handleWithdrawClick = () => {
    navigate('/account-withdraw');
  };

  const fetchTransactionList = async () => {
    try {
      const response = await listTransaction();
      setBalance(response.data);
    }
    catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTransactionList();
  }, []);

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[375px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        <p className="text-sm leading-6 mb-[15px] mt-0 tracking-wide font-lato font-semibold flex items-center">
          <span className="font-black me-1">
            <ChevronLeft size={16} onClick={handleGoBack} />
          </span>
          Transaction History
        </p>

        <div className="flex gap-3">
          <div className="flex flex-col items-center bg-gray-100 rounded-lg p-6 h-auto">
            <span className="font-lato text-sm text-[#536895]">{toIndianRupeeFormat(clients?.client_account?.balance)}</span>
            <div className="flex items-center">
              <span className="font-lato text-sm text-gray-900 font-semibold leading-6">Available Balance</span>
            </div>
          </div>
        </div>

        {/* Watchlist of Deposite/Withdraw */}
        {balance?.length > 0 ? (
          balance.map((item, index) => (
            <div key={item.id || index} className="flex gap-3 p-2 justify-between">
              <div className="flex flex-col bg-gray-100 rounded-lg p-3 h-auto w-full">
                <div className="flex justify-between w-full">
                  <span className="font-lato text-sm mb-2 text-gray-500">{dayjs(item.created_at).format("DD-MMM-YYYY HH:mm:ss").toUpperCase()}</span>
                  <span className="font-lato text-base font-semibold mb-2">{item.currency_symbol} {toIndianRupeeFormat(item.amount)}</span>
                </div>

                <div className="flex justify-between w-full items-center">
                  <div className="flex items-center">
                    {item.type === 'withdraw' ? (
                      <div className="bg-red-200 p-2 rounded-full">
                        <ArrowUpLeft size={16} className="text-red-800 stroke-1" />
                      </div>
                    ) : (
                      <div className="bg-green-200 p-2 rounded-full">
                        <ArrowUpRight size={16} className="text-green-800 stroke-1" />
                      </div>
                    )}

                    {item.type && (
                      <span className="font-lato font-bold text-sm ml-2">
                        {item.type.charAt(0).toUpperCase() + item.type.slice(1).toLowerCase()}
                      </span>
                    )}
                  </div>
                  <span className="font-lato text-xs text-red-800 bg-[#f236451a] px-2 py-1 rounded-[3px]">
                    CANCEL
                  </span>
                </div>

              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center">No items.</p>
        )}

        {/* <div className="flex gap-3 py-4 justify-between">
          <div className="flex flex-col bg-gray-100 rounded-lg p-3 h-auto w-full">
            <div className="flex justify-between w-full">
              <span className="font-lato text-sm mb-2 text-gray-500">2024-12-25 16:18:46</span>
              <span className="font-lato text-base font-semibold mb-2">₹ 1000.00</span>
            </div>
            
            <div className="flex justify-between w-full items-center">
              <div className="flex items-center">
                <div className="bg-green-200 p-2 rounded-full">
                  <ArrowUpRight size={16} className="text-green-800 stroke-1" />
                </div>
                <span className="font-lato font-bold text-sm ml-2">deposit</span>
              </div>
              <span className="font-lato text-xs text-red-800 bg-[#f236451a] px-2 py-1 rounded-[3px]">
                CANCEL
              </span>
            </div>
          </div>
        </div> */}

        {/* Deposit and Withdraw Buttons (Full Width) */}
        <div className="flex gap-3 mt-3 w-full">
          <button onClick={handleDepositClick}
            className="font-lato text-white text-base font-semibold py-3 px-8 flex-1 rounded-lg border border-[#2f67f0] bg-[#2f67f0] hover:bg-blue-700 min-w-[160px] leading-[20px]">
            Deposit
          </button>
          <button onClick={handleWithdrawClick}
            className="font-lato text-white text-base font-semibold py-3 px-8 flex-1 rounded-lg border border-[#f23645] bg-[#f23645] hover:bg-red-700 min-w-[160px] leading-[20px]">
            Withdraw
          </button>
        </div>

      </div>
    </div>
  );
}

export default TransactionHistory;